import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '@happenings/components/store';
import { getPostData } from '@happenings/components/post';
import UserList from '../common/UserList';

import { getFollowing, updateFollow } from '@happenings/components/entities/follows';
import { Attendance, AttendanceType, getAttendance, conjugateAttendanceStatus } from '@happenings/components/entities/attendance';

import LoadingIcon from '../common/LoadingIcon';

const AttendanceRow: React.FC<{ attendee: Attendance; }> = ({ attendee }) => {
  return (
    <div className="follow-row">
      <Link to={`/user/${attendee.username}`}>
        {attendee.display_name || attendee.username}
      </Link>
      {/* <span>{conjugateAttendanceStatus(attendee.status)}</span> */}
    </div>
  );
};

const mapState = (state: Store) => ({
  currentUser: state.session.currentUser,
  attendance: state.entities.attendance,
  // followData: state.entities.follows,
  // followingList: currentUserFollowing(state),
});

type StateProps = ReturnType<typeof mapState>;

type AppAction =
  | ReturnType<typeof getAttendance>
  | ReturnType<typeof getFollowing>
  | ReturnType<typeof updateFollow>;

type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapDispatchToProps = (dispatch: Dispatch<AppAction>) => ({
  init: (postId: number, username: string) => {
    dispatch(getAttendance(postId));
    dispatch(getPostData(postId));
    dispatch(getFollowing(username));
  },
  followHandler: (followeeUsername: string, val: boolean) => (
    dispatch(updateFollow(followeeUsername, val))
  ),
});

const connector = connect<StateProps, DispatchProps, {}, Store>(mapState, mapDispatchToProps);
type Props = ConnectedProps<typeof connector>;

// eslint-disable-next-line max-len
type Params = {
  event_id: string;
};

const AttendanceList: React.FC<Props> = ({ currentUser, init, attendance }) => {
  const { event_id } = useParams<Params>();
  const postId = parseInt(event_id, 10);
  const loaded = event_id in attendance;
  const attendanceList = loaded ? attendance[ event_id ] : [];
  const post = useSelector((state: Store) => state.entities.posts[ postId ]);

  useEffect(() => {
    if (currentUser) {
      init(postId, currentUser.username);
    }
  }, [ postId, currentUser ]);

  // I decided to remove the follow button from this list.. it's heavy and doesn't provide much value.
  // tgoodwin 01-02-24

  // const followHelper = (username, val) => followHandler(username, val);

  const renderAttendees = (attendees: Attendance[]) => (
    <div className="attendance-list">
      {attendees.map((attendee: Attendance) => {
        // const currUserIsFollowing = followingList.includes(attendee.username);
        return (
          <AttendanceRow attendee={attendee} key={attendee.username} />
        );
      })}
    </div>
  );

  if (!loaded || !post) {
    return <LoadingIcon />;
  }

  return (
    <div className="attendance-container">
      Attendance List for <Link to={`/event/${post.id}`}>{post.title}</Link>
      {/* {post.isPrivate ? (
        <RSVPList attendees={attendanceList} />
      ): (
        <UserList list={attendanceList} currentUsername={currentUser.username} />
        // renderAttendees(attendanceList)
      )} */}
    </div>
  );
};

export default connector(AttendanceList);

export const RSVPList: React.FC<{ attendees: Attendance[], isPrivate: boolean; }> = ({ attendees, isPrivate }) => {
  const [ selection, setSelection ] = React.useState<AttendanceType>(AttendanceType.GOING);
  const tabList = attendees.filter((attendee) => attendee.status === selection);
  const statusCounts = attendees.reduce((acc, attendee) => {
    acc[ attendee.status ] = (acc[ attendee.status ] || 0) + 1;
    return acc;
  }, {} as Record<AttendanceType, number>);

  const tabOptions = [
    { label: 'Going', count: statusCounts[ AttendanceType.GOING ] || 0, value: AttendanceType.GOING },
    { label: "Can't go", count: statusCounts[ AttendanceType.NOT_GOING ] || 0, value: AttendanceType.NOT_GOING },
    { label: 'Maybe', count: statusCounts[ AttendanceType.MAYBE ] || 0, value: AttendanceType.MAYBE },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '10px' }}>
        {tabOptions.map((tab) => (
          <div key={tab.value}>
            <button
              style={{
                textDecoration: selection === tab.value ? 'underline' : 'none',
                textDecorationThickness: 2,
              }}
              onClick={() => setSelection(tab.value)}
            >
              <span className="tab-label">{tab.label}</span>
            </button>
            <span className="tab-count"> ({tab.count})</span>
          </div>
        ))}
      </div>
      <div className="tab-content">
        {tabList.map((attendee) => (
          <div key={attendee.id}>
            <Link to={`/user/${attendee.username}`}>
              {attendee.display_name || attendee.username}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
